import { IRemapper } from "../../../../Global/IRemapper";
import ExternalActivityModel from "../ExternalActivity/ExternalActivityModel";

export default class ExternalActivityRemapper
  implements IRemapper<ExternalActivityModel[]>
{
  fromResponse(response: any): ExternalActivityModel[] {
    return response.map((r) => {
      const model = new ExternalActivityModel();

      model.id = r.id;
      model.datetime = r.datetime;
      model.status = r.status;

      return model;
    });
  }
}
